import { render, staticRenderFns } from "./FooterLogin.vue?vue&type=template&id=6ae88d8c&scoped=true"
import script from "./FooterLogin.vue?vue&type=script&lang=js"
export * from "./FooterLogin.vue?vue&type=script&lang=js"
import style0 from "./FooterLogin.vue?vue&type=style&index=0&id=6ae88d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae88d8c",
  null
  
)

export default component.exports